import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { LocationListActionsCell } from './location-list-actions.cell';
import { LocationListActionsHeader } from './location-list-actions.header';

export const LocationListActionsColumn: DisplayColumnDef<
  GatewayLocationModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: LocationListActionsHeader,
  cell: LocationListActionsCell,
};
